<template>
    <div class="login">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="login-wrap d-md-flex">
                    <div class="login-img"></div>
                    <div class="login-box p-4 p-md-5">
                        <div class="login-logo mb-3 d-flex justify-content-center flex-column">
                            <img
                                src="../assets/brand/logo_groepsapp.svg"
                                alt="Groepsapp logo"
                            />
                        </div>
                        <login-form
                            v-if="showLoginForm"
                            @login="afterLogin($event)"
                        />
                        <p
                            v-else
                            class="text-center fw-bold pt-4 mb-4"
                        >
                            Een ogenblik geduld...
                        </p>
                        <p class="text-center small text-body-secondary mb-2">
                            {{ app.name }} {{ app.tag }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/Login-Form.vue'

export default {
    name: 'login',
    components: {
        LoginForm
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        }
    },
    data() {
        return {
            showLoginForm: false
        }
    },
    created() {
        if (
            this.deviceToken
            &&
            this.session
            &&
            this.session.session_token
        ) {
            this.$request.get('/authentication/is-valid')
                .then((response) => {
                    if (
                        response
                        &&
                        response.success
                        &&
                        response.success === true
                    ) {
                        this.$router.push('/dashboard')
                    } else {
                        this.$router.push('/logout')
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$router.push('/logout')
                })
        } else {
            this.showLoginForm = true
        }
    },
    methods: {
        afterLogin() {
            this.$store.dispatch('loadApplicationSettings')
            this.$router.push('/select-establishment')
        }
    }
}
</script>
